"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Badge_component_exports = {};
__export(Badge_component_exports, {
  Badge: () => Badge,
  BadgeColor: () => BadgeColor,
  BadgeType: () => BadgeType
});
module.exports = __toCommonJS(Badge_component_exports);
var import_react = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
var import_Badge = require("./Badge.styled");
var _excluded = ["aria-label", "text", "badgeColor", "className", "badgeType", "iconSize", "as", "role", "customStyles"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var BadgeType = /* @__PURE__ */ function(BadgeType2) {
  BadgeType2["round"] = "round";
  BadgeType2["squared-round"] = "squared-round";
  return BadgeType2;
}({});
var BadgeColor = /* @__PURE__ */ function(BadgeColor2) {
  BadgeColor2["transparent"] = "transparent";
  BadgeColor2["beige"] = "beige";
  BadgeColor2["khaki"] = "khaki";
  BadgeColor2["olive"] = "olive";
  BadgeColor2["orange"] = "orange";
  BadgeColor2["pr"] = "pr";
  BadgeColor2["white"] = "white";
  return BadgeColor2;
}({});
var BadgeName = function BadgeName2(_ref) {
  var as = _ref.as, ariaAs = _ref.ariaAs, role = _ref.role, children = _ref.children;
  var As = (0, import_styled_components.default)(as).withConfig({
    displayName: "Badgecomponent__As",
    componentId: "sc-12er3ct-0"
  })(["margin-block-start:0em;margin-block-end:0em;margin-inline-start:0em;margin-inline-end:0em;"]);
  var elementRole = as === "div" || as === "span" || as === "p" ? role : null;
  return /* @__PURE__ */ import_react.default.createElement(As, {
    "aria-label": ariaAs,
    role: elementRole
  }, children);
};
var Badge = function Badge2(_ref2) {
  var ariaLabel = _ref2["aria-label"], _ref2$text = _ref2.text, text = _ref2$text === void 0 ? "" : _ref2$text, _ref2$badgeColor = _ref2.badgeColor, badgeColor = _ref2$badgeColor === void 0 ? "transparent" : _ref2$badgeColor, _ref2$className = _ref2.className, className = _ref2$className === void 0 ? "DefaultBadge" : _ref2$className, _ref2$badgeType = _ref2.badgeType, badgeType = _ref2$badgeType === void 0 ? "round" : _ref2$badgeType, _ref2$iconSize = _ref2.iconSize, iconSize = _ref2$iconSize === void 0 ? 17 : _ref2$iconSize, _ref2$as = _ref2.as, as = _ref2$as === void 0 ? "div" : _ref2$as, _ref2$role = _ref2.role, role = _ref2$role === void 0 ? "status" : _ref2$role, _ref2$customStyles = _ref2.customStyles, customStyles = _ref2$customStyles === void 0 ? "" : _ref2$customStyles, props = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_Badge.StyledBadge, {
    className,
    icon: props.icon,
    text,
    badgeType,
    badgeColor,
    "data-dp-analytics-id": props.dataDpAnalyticsId,
    "data-testid": "badge",
    customStyles
  }, /* @__PURE__ */ import_react.default.createElement(BadgeName, {
    as,
    ariaAs: ariaLabel,
    role
  }, /* @__PURE__ */ import_react.default.createElement("span", {
    "data-testid": "badge-test-icon-container"
  }, props.icon && /* @__PURE__ */ import_react.default.createElement(import_Badge.StyledIcon, {
    icon: props.icon,
    text,
    size: iconSize
  }), /* @__PURE__ */ import_react.default.createElement("span", null, text && text.trim())))));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Badge,
  BadgeColor,
  BadgeType
});
//# sourceMappingURL=Badge.component.js.map